import script from "./AppTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./AppTextEditor.vue?vue&type=style&index=0&id=47552022&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47552022"]])

export default __exports__